import { isSameDay } from 'date-fns'

import IMsDateInterval from '~/client/src/shared/types/IMsDateInterval'

// Kept free of store imports so ProjectDate.store can resolve the mode itself —
// intervalFormatters imports ProjectDateStore, so living there would be a cycle.

// Prefer the stored Daily/Date mode; fall back to same-day inference only for
// legacy intervals saved before the backend persisted isDaily. Shared by the
// display formatter, the editor seeding and the operating-window engines so an
// existing interval renders, re-opens and validates in the same mode.
export function resolveOperatingIntervalIsDaily({
  startDate,
  endDate,
  isDaily,
  dayOfWeek,
}: IMsDateInterval): boolean {
  // A weekday-scoped window recurs whatever isDaily says — the server reads the
  // weekday first and treats the flag as unset.
  if (isWeekdayNumber(dayOfWeek)) return true

  return typeof isDaily === 'boolean'
    ? isDaily
    : endDate == null || isSameDay(startDate, endDate)
}

/** Whether a number names a real weekday, 1 = Sunday .. 7 = Saturday. */
export function isWeekdayNumber(dayOfWeek: number | undefined): boolean {
  return dayOfWeek != null && dayOfWeek >= 1 && dayOfWeek <= 7
}

/** Whether the window belongs to one named weekday rather than to every day. */
export function isWeekdayScopedInterval(interval: IMsDateInterval): boolean {
  return isWeekdayNumber(interval.dayOfWeek)
}

// Seeds an operating interval with its Daily/Date mode resolved, so an existing
// interval re-opens on the tab it displays as — and saving a dated window can't
// silently collapse to "today" via the default Daily tab.
export function withResolvedOperatingMode(
  interval: IMsDateInterval,
): IMsDateInterval {
  return { ...interval, isDaily: resolveOperatingIntervalIsDaily(interval) }
}
